import { Button } from '@material-ui/core';
import React, { useState } from 'react'
import { QueryBuilder, defaultOperators, formatQuery } from 'react-querybuilder';

import 'react-querybuilder/dist/query-builder.css';

export default function Filtrolp(props) {
  const initialQuery = { combinator: 'and', rules: [] };

  const [query, setQuery] = useState(initialQuery);

  const onSubmitQuery = () => {
    console.log(formatQuery(query, 'sql'));
    props.onFilter(query);
  }

  return (
    <div>
      <QueryBuilder
        controlElements={{
          addGroupAction: () => null,
        }}
        fields={[{
          name: 'lpe.id_lista_precio_tipo',
          label: 'Tipo Cobro',
          placeholder: 'Cobros',
          operators: defaultOperators.filter((op) => op.name === '='),
          valueEditorType: 'select',
          values: [{
            label: 'Tipos',
            options: props.ops.tipos_listas.map(tl => ({ name: tl.id, label: tl.lpt_nombre, value: tl.id }))
          }],
        },
        {
          name: 'lpe.valor_aplicado',
          label: 'Valor Aplicado',
          inputType: 'number',
          placeholder: 'Valor',
          operators: defaultOperators.filter((op) => ['=', '!=', '<', '>', '<=', '>=', 'between'].includes(op.name)),
        },
        {
          name: 'origen_destino',
          label: 'Origen/Destino',
          placeholder: 'Origen/Destino',
          operators: defaultOperators.filter((op) => op.name === 'between'),
          defaultOperator: 'between',
          valueEditorType: 'select',
          values: [{
            label: 'Sucursales',
            options: props.ops.destinos.map(tl => ({ name: tl.id, label: tl.sucursal, value: tl.id }))
          }],
        },
        {
          name: 'km',
          label: 'Kilometros',
          placeholder: 'Kilometros',
          inputType: 'number',
          operators: defaultOperators.filter((op) => ['=', '!=', '<', '>', '<=', '>=', 'between'].includes(op.name)),
        },
        {
          name: 'id_zona',
          label: 'Zona',
          placeholder: 'Zona',
          operators: defaultOperators.filter((op) => op.name === '='),
          valueEditorType: 'select',
          values: [{
            label: 'Zonas',
            options: props.ops.zonas.map(tl => ({ name: tl.id, label: tl.zona, value: tl.id }))
          }],
        },
        {
          name: 'kg_rango',
          label: 'Kilos(Rango)',
          placeholder: 'Kg',
          defaultOperator: 'between',
          inputType: 'number',
          operators: defaultOperators.filter((op) => op.name === 'between'),
        },
        {
          name: 'ruta',
          label: 'Ruta',
          placeholder: 'Ruta',
          operators: defaultOperators.filter((op) => op.name === '='),
          valueEditorType: 'select',
          values: [{
            label: 'Rutas',
            options: props.ops.rutas.map(tl => ({ name: tl.id, label: tl.ruta, value: tl.id }))
          }],
        }
        ]}
        query={query}
        onQueryChange={(q) => setQuery(q)}
      />
      <Button onClick={onSubmitQuery} color='primary' variant='contained' >
        Filtrar
      </Button>
    </div>
  )
}
